<template>
<div
    v-if="quoteFreight.excluded_methods.length > 0">
    <h2 class="subtitle has-text-weight-bold has-text-primary is-size-4">
        Opções nāo disponiveis ({{ quoteFreight.excluded_methods.length }})
    </h2>

    <div class="columns sc-excluded-methods-column">
        <div
            class="column is-4"
            v-for="(excludedMethod, excludedMethodKey) in quoteFreight.excluded_methods"
            :key="excludedMethodKey">
            <sc-card>
                <template slot="header">
                    <p class="has-text-primary is-size-6 card-header-title">
                        {{ excludedMethod.name }}
                    </p>
                </template>

                <template slot="body">
                    <div class="columns">
                        <div class="column">
                            <figure class="image is-128x128">
                                <img
                                    :src="excludedMethod.logo_url"
                                    :alt="excludedMethod.name" />
                            </figure>

                        </div>
                        <div class="column">
                            <p 
                                v-for="(deliveryRestriction, deliveryRestrictionKey)
                                in excludedMethod.delivery_restrictions"
                                :key="deliveryRestrictionKey"
                                class="heading">
                                  {{ deliveryRestriction }}
                            </p>
                        </div>
                    </div>
                </template>
            </sc-card>
        </div>
    </div>
</div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScCard,
} from '@intelipost-js/secure-components';

const { mapState } = createNamespacedHelpers('quote/freightQuote');

export default {
  name: 'sc-excluded-methods',
  computed: {
    ...mapState([
      'quoteFreight',
    ]),
  },
  components: {
    ScCard,
  },
};
</script>
<style lang="scss" scoped>
  .sc-excluded-methods-column {
    flex-flow: row wrap;
  }
</style>


// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-excluded-methods/ScExcludedMethods.vue?392c3ce8